<!--
  新建 发票管理特殊字段
  prop:
    item: 绑定对象
    form: form表单数据对象
 -->

<template>
  <div class="redundant">
    <!-- 关联客户 -->
    <template v-if="item.attr === 'customerName'">
      <associated-field
        ref="associatedField"
        module="customerApi"
        :item="item"
        :form="form"
        @addNew="addNew"
        @emitObj="customerChange"
        >
      </associated-field>
    </template>

    <!-- 关联原始发票 -->
    <template v-if="item.attr === 'originId'">
      <el-input disabled v-model="item.attrValue.value" :readonly="true">
      </el-input>
    </template>

    <!-- 关联合同 -->
    <template v-if="item.attr === 'contractId'">
      <associated-field
        v-if="form.customerName&&form.customerName.id"
        module="contractApi"
        :item="item"
        :form="form"
        :customerId="form.customerName.id"
        :multiselect="true"
        @addNew="addNew"
        @emitObj="relationChange">
      </associated-field>
      <span v-else>无</span>
    </template>

    <!-- 关联回款 -->
    <template v-if="item.attr === 'paymentId'">
      <div class="item-select" v-if="form.contractId && form.contractId.length === 1" :class="{'disable': item.nonEditable === 1}">
        <el-input
          :placeholder="'请点击“选择”添加'"
          v-if="!form[item.attr].id && form[item.attr].length === 0"
          :readonly="true"
        >
        </el-input>
        <span class="item" v-for="(con, i) in form[item.attr]">
          <span class="text">{{con.value}}</span>
          <i class="del el-icon-close" @click="del(i)"></i>
        </span>
        <el-button type="text" class="select-btn" @click="contactShow = !contactShow">选择</el-button>
      </div>
      <span v-else>无</span>
      <mult-select
        v-if="contactShow"
        @emitObj="relationChange"
        @close="contactShow=false"
        module="payment"
        :contractId="form.contractId[0].id ? form.contractId[0].id : ''"
        :attrValue="form[item.attr]">
      </mult-select>
    </template>

    <!-- 申请人 -->
    <template v-if="item.attr === 'userId'">
      <v-manager
        :item="item"
        :form="form">
      </v-manager>
    </template>
  </div>
</template>

<script>
import remoteSelect from '../remote-select'
import multSelect from 'components/modal/mult-select'
import vManager from '../manager'
import { mapActions } from 'vuex'
import associatedField from '../associated-field'
import * as api from 'src/api'
export default {
  props: ['item', 'form', 'detailId'],
  data () {
    return {
      contactShow: false
    }
  },
  methods: {
    ...mapActions([
      'setWarehouseId',
      'setAttr'
    ]),

    // 关联客户改变时，重新获取发票信息
    customerChange (obj) {
      // debugger 关联客户修改时将obj中客户信息发送后台得到totalMoney赋值this.form.totalMoney
      this.form.contractId = []
      this.form.paymentId = []
      this.form.totalMoney = 0
    },

    // 关联变更时，清空关联回款
    relationChange (arr) {
      // let totalMoney = 0
      this.form['paymentId'] = []
      this.form[this.item.attr] = arr
      this.setAttr(this.item.attr)
      // 关联合同变化时将arr中信息发送后台请求金额赋值this.form.totalMoney
      let requestUrl = 'invoice/balance.html'
      let requestParams = {'id': this.detailId, 'contractId': this.form.contractId, 'paymentId': this.form.paymentId}
      if (this.item.attr === 'paymentId') {
        requestParams = Object.assign(requestParams, {'paymentId': arr})
      } else {
        requestParams = Object.assign(requestParams, {'contractId': arr})
      }
      api.post(requestUrl, {'defaultData': requestParams}, (data) => {
        this.form.totalMoney = data.balance
      }, (data) => {
        this.form.totalMoney = 0
      })
      // for (let i = 0; i < arr.length; i++) {
      //   totalMoney = utils.plus(totalMoney, arr[i].amount)
      // }

      // if (totalMoney === 0 && this.form['contractId'].length > 0) {
      //   for (let i = 0; i < this.form['contractId'].length; i++) {
      //     // totalMoney += this.form['contractId'][i].amount
      //     totalMoney = utils.plus(totalMoney, this.form['contractId'][i].amount)
      //   }
      // }
      // this.form.totalMoney = totalMoney
    },

    addNew (obj) {
      this.$emit('addNew', obj)
    },
    refresh () {
      if (this.$refs.associatedField) {
        this.$refs.associatedField.refresh()
      }
    },
    del (i) {
      this.form[this.item.attr].splice(i, 1)
      this.relationChange(this.form[this.item.attr])
    }
  },
  filters: {
    productLen (arr) {
      let num = 0
      arr.forEach((item) => {
        num += item.num
      })
      num = Number(num.toFixed(5))
      return `${arr.length}种产品${num}件`
    }
  },
  components: {
    remoteSelect,
    associatedField,
    multSelect,
    vManager
  }
}
</script>
<style lang="less" scoped>
  @import '../../../assets/less/remote-select.less';
  @import '../../../assets/less/fieldtype-products.less';
  &.disable {
      background-color: #eef1f6;
      border: 1px solid #d1dbe5;
      color: #bbb;
      .select-btn {
        background-color: transparent;
      }
      &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 100%;
        left: 0;
        top: 0;
        opacity: 0;
        cursor: not-allowed;
      }
    }
</style>



// WEBPACK FOOTER //
// index.vue?0615cb26